"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PublicLayout = function (_a) {
    var children = _a.children;
    return children;
};
exports.default = PublicLayout;
//# sourceMappingURL=index.js.map